import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateCustomField($companyId: ID!, $id: ID!, $attributes: CustomFieldAttributes!) {
    updateCustomField(companyId: $companyId, id: $id, attributes: $attributes) {
      customField {
        id
        ...UpdatedCustomField
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedCustomField on CustomField {
    id
    name
    resourceType
    fieldType
    enabled
  }
`
